import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from "./Ghost.module.less";
export const Ghost = (props) => {
    const { show = true, duration = 1000, } = props;
    if (!show)
        return null;
    return (_jsx("div", { className: styles.ghost, style: { animationDuration: `${duration}ms` } }));
};
